/** Popup with active sprint details
 * spec: https://www.figma.com/design/YnMz1EvyBCySecvWX4FvHC/%F0%9F%A7%AD-%5BSpork%5D-Jira-navigation-refresh---Components-%26-patterns?node-id=11291-21447&node-type=FRAME&t=76M0RECVACsXpZVQ-0
 */
import React from 'react';
import { Text } from '@atlaskit/primitives';
import type { Sprint } from '../../../../model/sprint/sprint-types.tsx';

export interface Props {
	activeSprints: Array<Sprint>;
}
const PopupContent = (props: Props) => {
	const { activeSprints } = props;

	return (
		<>
			{activeSprints.map((sprint) => (
				<SprintFullDetails key={sprint.id} sprint={sprint} />
			))}
		</>
	);
};

export default PopupContent;

export function SprintFullDetails({ sprint }: { sprint: Sprint }) {
	return (
		<>
			<SprintSummary sprint={sprint} />
		</>
	);
}

export function SprintSummary({ sprint }: { sprint: Sprint }) {
	return (
		<>
			<Text weight="bold" as="strong">
				{sprint.name}
			</Text>
			<Text as="p">{sprint.goal}</Text>
		</>
	);
}
